// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"148":"29fca7281f03e03d","487":"ecf439ae04ff46e4","552":"f500c3efb65d9939","907":"47df16289af8c51c"}[chunkId] + ".js";
};